import { render } from "./TextTruncate.vue?vue&type=template&id=c9258bea&scoped=true"
import script from "./TextTruncate.vue?vue&type=script&lang=js"
export * from "./TextTruncate.vue?vue&type=script&lang=js"

import "./TextTruncate.vue?vue&type=style&index=0&id=c9258bea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9258bea"]])

export default __exports__